import { ColDef, type ICellRendererParams } from "ag-grid-community";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { IsResourceBillableCellRenderer } from "../column-def-cell-renderers/IsResourceBillableCellRenderer";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { getResourceSizeColumnDef } from "../common/getResourceSizeColumnDef";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { FilteredEbsSnapshotResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const ebsSnapshotColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  {
    field: "resource.snapshot_id",
    headerName: "Snapshot ID",
  },

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("ebs_snapshot"),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  resourceCreatedByColumnDef,

  getResourceCreationTimeColumnDef("Start Time"),

  {
    field: "resource.storage_tier",
    headerName: "Storage Tier",
  },

  getResourceSizeColumnDef({
    propName: "volume_size",
    headerName: "Volume Size",
  }),

  {
    field: "resource.status",
    headerName: "Snapshot Status",
  },

  {
    field: "resource.volume_id",
    headerName: "Volume ID",
  },

  {
    field: "resource.total_siblings",
    headerName: "Snapshots per Volume",
  },

  {
    field: "resource.is_encrypted",
    headerName: "Encrypted",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredEbsSnapshotResourceItem>) => {
      return String(!!data?.resource?.is_encrypted);
    },
  },

  {
    field: "resource.is_snapshot_used",
    headerName: "In Use",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredEbsSnapshotResourceItem>) => {
      if (!data) {
        return null;
      }

      const isUsed = data?.resource?.is_snapshot_used;

      return (
        <Stack>
          <Typography variant="body2">{isUsed ? "Used By" : "No"}</Typography>

          {isUsed && (
            <TypographyWithTooltip
              title={data?.resource?.used_by_image ?? ""}
              fontSize="small"
              color="text.disabled"
            />
          )}
        </Stack>
      );
    },
  },

  {
    field: "resource.billable",
    headerName: "Billable",
    cellRenderer: IsResourceBillableCellRenderer,
  },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
